function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0013 2.66675C12.4651 2.66675 9.0737 4.07151 6.57321 6.57199C4.07273 9.07248 2.66797 12.4639 2.66797 16.0001C2.66797 19.5363 4.07273 22.9277 6.57321 25.4282C9.0737 27.9287 12.4651 29.3334 16.0013 29.3334C19.5375 29.3334 22.9289 27.9287 25.4294 25.4282C27.9299 22.9277 29.3346 19.5363 29.3346 16.0001C29.3346 12.4639 27.9299 9.07248 25.4294 6.57199C22.9289 4.07151 19.5375 2.66675 16.0013 2.66675Z",
  stroke: "#1D9E75",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.9999L14.6667 18.6666L20 13.3333",
  stroke: "#1D9E75",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSavedToCrm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedToCrm);
export default __webpack_public_path__ + "static/media/saved-to-crm.660af0da.svg";
export { ForwardRef as ReactComponent };